function getItemName(item, language) {
  if (language === 'ro' && item.nameRo) {
    return item.nameRo;
  }
  return item.name;
}

/** Plain-text cart order for WhatsApp / email checkout. */
export function buildOrderSummary({
  cart,
  language,
  formatPrice,
  subtotal,
  shippingAmount,
  total,
  labels
}) {
  const lines = [labels.heading, ''];

  cart.forEach((item) => {
    const name = getItemName(item, language);
    const lineTotal = item.price * item.quantity;
    lines.push(
      `${name} — ${item.weight} × ${item.quantity}: ${formatPrice(lineTotal)}`
    );
  });

  lines.push('');
  lines.push(`${labels.subtotal}: ${formatPrice(subtotal)}`);
  lines.push(
    `${labels.shipping}: ${
      shippingAmount === 0 ? labels.free : formatPrice(shippingAmount)
    }`
  );
  lines.push(`${labels.total}: ${formatPrice(total)}`);
  lines.push('');
  lines.push(`${labels.seller}: ${labels.sellerName}`);
  lines.push(`${labels.pickup}: ${labels.pickupPlace}`);

  return lines.join('\n');
}
